import React from "react";

import { Tooltip, TooltipProps } from "@mui/material";

import { PartialBy } from "@app/common/types";

type CopiedTooltipProps = PartialBy<TooltipProps, "title">;

const CopiedTooltip = ({
  children,
  title = "Copied!",
  ...rest
}: CopiedTooltipProps) => {
  return (
    <Tooltip
      PopperProps={{ disablePortal: true }}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      arrow
      title={title}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default CopiedTooltip;
